import React, { Fragment, useEffect, useRef, useState } from 'react'
import { withRouter } from 'react-router'

import { DI } from 'modules'
import Component from 'components/component'
import Validator from 'components/validator'
import Form from 'common/components/form/new-form'
import { humanize } from 'helpers/strings'
import * as routes from 'config/routes'
import { Link } from 'components/link'
import { tos, privacyPolicy } from 'config/routes'
// import InvisibleRecaptcha from 'components/invisible-recaptcha';
import { IS_LANDING, EXTERNAL_LANDING_ID } from 'config'
import { TextInputField } from 'components/form/text-input'

const onValidateForm = () => {}

function parseErrors(body) {
  const errors = []
  Object.keys(body.errors).forEach(key => {
    errors.push(
      ...body.errors[key].map(text => [humanize(key), text].join(' '))
    )
  })
  return errors
}

function FormSignUpModal(props) {
  // const recaptchaRef = React.createRef();
  const [form, setForm] = useState({
    email: '',
    newsletter_notify: 'on',
  })
  const [loading, setLoading] = useState(false)
  const [serverErrors, setErrors] = useState([])

  const onRecaptchaPassed = result => {
    const formData = {
      ...form,
      is_landing_user: IS_LANDING ? true : false,
      ...(IS_LANDING ? { external_landing_id: EXTERNAL_LANDING_ID } : {}),
      profile_locale: props.common.locale,
    }

    props.actions.user
      .signUp(formData)
      .then(resp => {
        props.onClose && props.onClose()
        props.history.push(`/${props.common.locale}/check-email`)
      })
      .catch(err => {
        setErrors(parseErrors(err.response.body))
        setLoading(false)
      })
  }

  const onChange = (ev, form) => setForm(form)
  const onSubmit = (ev, form) => {
    if (form.agreeTerms && onValidateForm.panic()) {
      setLoading(true)
      onRecaptchaPassed()
      // recaptchaRef.current.execute(config.RECAPTCHA_KEY, {
      //     action: 'defaultAction'
      // });
    }
  }

  const strings = props.common.strings
  const buttonClassName = Component.classList(
    'button button--free',
    loading && '_loading'
  )

  return (
    <Fragment>
      <span className="sign-in__title">{strings['signup.title']}</span>
      <div className="sign-in-text sign-in-text--pre">
        <p>
          {strings['signup.signin.before_link']}{' '}
          {props.openSignInModal ? (
            <a href="#" onClick={props.openSignInModal}>
              {strings['signup.signin.link.text']}
            </a>
          ) : (
            <Link to={routes.signin.getPath()} onClick={props.onClose}>
              {strings['signup.signin.link.text']}
            </Link>
          )}
        </p>
      </div>
      <div className="sign-in-form j-terms">
        <Form onChange={onChange} onSubmit={onSubmit}>
          <Validator
            value={form.email}
            validators={['isRequired', 'isEmail']}
            onValidateForm={onValidateForm}
            render={({ hasError, value, messages }) => (
              <Fragment>
                <div className="field">
                  <input
                    type="text"
                    className="input"
                    placeholder={strings['signup.email.placeholder']}
                    name="email"
                    value={value}
                    hasError={messages[0]}
                  />
                </div>
                {(hasError || serverErrors.length) && (
                  <div className="error">
                    {messages.concat(serverErrors)[0]}
                  </div>
                )}
              </Fragment>
            )}
          />
          <div className="field field--su-checkbox">
            <div className="checkbox">
              <input
                type="checkbox"
                checked={form.agreeTerms}
                className="checkbox__input"
                id="agreeTerms"
                name="agreeTerms"
              />
              <label htmlFor="agreeTerms" className="checkbox__label">
                {strings['signup.terms.text']}{' '}
                <Link to={tos.getPath()} onClick={() => props.onClose()}>
                  {strings['signup.terms.link']}
                </Link>
                {', '}
                {strings['signup.privacy.text']}
                <Link
                  to={privacyPolicy.getPath()}
                  onClick={() => props.onClose()}
                >
                  {strings['signup.privacy.link']}
                </Link>
              </label>
            </div>
          </div>
          {/* <div className="field field--su-checkbox">
            <div className="checkbox">
              <input
                type="checkbox"
                checked={form.newsletter_notify}
                className="checkbox__input"
                id="newsletter_notify"
                name="newsletter_notify"
              />
              <label htmlFor="newsletter_notify" className="checkbox__label">
                {strings['signup.newsletters.text']}
              </label>
            </div>
          </div> */}
          {/*<InvisibleRecaptcha*/}
          {/*    ref={recaptchaRef}*/}
          {/*    onPassed={() => onRecaptchaPassed()}*/}
          {/*    onFail={() => setLoading(false)}*/}
          {/*    actions={props.actions.recaptcha}*/}
          {/*/>*/}
          <div className="field field--submit">
            <button
              type="submit"
              className={buttonClassName}
              disabled={!form.agreeTerms}
            >
              {strings['signup.button.text']}
              <span className="button__loading">
                {strings['signup.button.loading']}
                ...
              </span>
            </button>
          </div>
        </Form>
      </div>
      <div className="sign-in-link sign-in-link--already">
        <span className="sign-in-link__label">
          {strings['signup.signin.will_get_link']}
        </span>
      </div>
    </Fragment>
  )
}

const RE_NAME = /^[A-Za-zА-Яа-яЁё\s\-']{2,100}$/
const RE_MEDIA = /^[A-Za-zА-Яа-яЁё0-9\s.,\-«»]{2,200}$/
const RE_PHONE = /^\+[0-9 ()-]{4,19}$/

const isEmailLengthValid = value => {
  const email = String(value)
  const at = email.lastIndexOf('@')
  if (at === -1) {
    return true
  }
  return at <= 64 && email.length - at - 1 <= 255
}

const isEmailFormatValid = value => {
  const [local, domain] = String(value).split('@')
  if (domain === undefined) {
    return true
  }
  if (local.startsWith('.') || local.endsWith('.') || local.includes('..')) {
    return false
  }
  return domain.split('.').every(label => label.length <= 63)
}

const normalize = form => ({
  name: form.name.trim(),
  media: form.media.trim(),
  email: form.email.trim().toLowerCase(),
  phone: form.phone.trim(),
})

const INPUT_FIELDS = ['name', 'media', 'email', 'phone']

const CODE_STRING_KEYS = {
  email_invalid: 'signup.page.email.format_error',
}

const readHoneypot = serialized => {
  const value = serialized.website
  return value === undefined || value === null ? '' : String(value)
}

const COOLDOWN_KEY = 'registration-request:retry-at'
const COOLDOWN_MS = 30000

const readCooldown = () => {
  try {
    return Number(sessionStorage.getItem(COOLDOWN_KEY)) || 0
  } catch (err) {
    return 0
  }
}

const writeCooldown = retryAt => {
  try {
    sessionStorage.setItem(COOLDOWN_KEY, String(retryAt))
  } catch (err) {}
}

function FormSignUpPage(props) {
  const { strings } = props.common
  const [form, setForm] = useState({
    name: '',
    media: '',
    email: '',
    phone: '',
  })
  const [agreeTerms, setAgreeTerms] = useState(false)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [fieldErrors, setFieldErrors] = useState({})
  const [commonErrors, setCommonErrors] = useState([])
  const [cooldown, setCooldown] = useState(false)

  const [nameValid, setNameValid] = useState(false)
  const [mediaValid, setMediaValid] = useState(false)
  const [emailValid, setEmailValid] = useState(false)
  const [phoneValid, setPhoneValid] = useState(false)
  const [termsValid, setTermsValid] = useState(false)

  const inFlight = useRef(false)
  const skipCooldown = useRef(false)
  const mounted = useRef(true)
  const timer = useRef(null)

  useEffect(() => {
    const remaining = readCooldown() - Date.now()
    if (remaining > 0) {
      setCooldown(true)
      timer.current = setTimeout(() => setCooldown(false), remaining)
    }
    return () => {
      mounted.current = false
      clearTimeout(timer.current)
    }
  }, [])

  const startCooldown = () => {
    const retryAt = Date.now() + COOLDOWN_MS
    writeCooldown(retryAt)
    if (!mounted.current) {
      return
    }
    setCooldown(true)
    clearTimeout(timer.current)
    timer.current = setTimeout(() => setCooldown(false), COOLDOWN_MS)
  }

  const errorText = ({ field, code }) =>
    strings[CODE_STRING_KEYS[code]] ||
    (String(code).endsWith('_blank') &&
      strings['signup.page.error.required']) ||
    strings[`signup.page.${field}.error`] ||
    strings['signup.page.error.validation']

  const parseErrorList = errors => {
    const byField = {}
    const common = []

    ;[].concat(errors || []).forEach(error => {
      if (!error || typeof error !== 'object') {
        return
      }
      const text = errorText(error)
      if (INPUT_FIELDS.includes(error.field)) {
        if (!byField[error.field]) {
          byField[error.field] = text
        }
      } else if (!common.includes(text)) {
        common.push(text)
      }
    })

    return { byField, common }
  }

  const onChange = (ev, nextForm) => {
    setForm({
      name: nextForm.name || '',
      media: nextForm.media || '',
      email: nextForm.email || '',
      phone: nextForm.phone || '',
    })
    const field = ev.target && ev.target.name
    if (field && fieldErrors[field]) {
      setFieldErrors(rest => {
        const next = { ...rest }
        delete next[field]
        return next
      })
    }
  }

  const onSubmit = (ev, serialized = {}) => {
    if (inFlight.current || cooldown) {
      return
    }
    inFlight.current = true
    setLoading(true)
    setMessage('')
    setFieldErrors({})
    setCommonErrors([])

    props.actions.user
      .requestRegistration({
        ...normalize(form),
        consent: true,
        website: readHoneypot(serialized),
      })
      .then(() => {
        if (!mounted.current) {
          return
        }
        props.history.push(
          `/${props.common.locale}${routes.signupThankYou.getPath()}`
        )
      })
      .catch(err => {
        const status = err.status || err.response?.status
        const body = err.response?.body || {}

        if (!mounted.current) {
          return
        }
        if (status === 400) {
          skipCooldown.current = true
          const { byField, common } = parseErrorList(body.errors)
          setFieldErrors(byField)
          setCommonErrors(
            common.length || Object.keys(byField).length
              ? common
              : [strings['signup.page.error.validation']]
          )
        } else if (status === 409) {
          setMessage(strings['signup.page.error.duplicate'])
        } else if (status === 429) {
          setMessage(strings['signup.page.error.limited'])
        } else {
          setMessage(strings['signup.page.error.network'])
        }
      })
      .then(() => {
        inFlight.current = false
        if (skipCooldown.current) {
          skipCooldown.current = false
        } else {
          startCooldown()
        }
        if (mounted.current) {
          setLoading(false)
        }
      })
  }

  const buttonClassName = Component.classList(
    'auth-form__submit',
    loading && '_waiting'
  )
  const formClassName = Component.classList(
    'auth-form j-terms',
    loading && '_loading'
  )
  const canSubmit =
    nameValid &&
    mediaValid &&
    emailValid &&
    phoneValid &&
    termsValid &&
    !loading &&
    !cooldown

  return (
    <div className={formClassName}>
      <Form onChange={onChange} onSubmit={onSubmit}>
        <TextInputField
          isRequired
          name="name"
          serverError={fieldErrors.name}
          title={strings['signup.page.name.placeholder']}
          type="text"
          maxLength={100}
          value={form.name}
          validators={[
            {
              name: 'signupName',
              func: value => RE_NAME.test(value),
              message: strings['signup.page.name.error'],
            },
          ]}
          onValidate={setNameValid}
        />
        <TextInputField
          isRequired
          name="media"
          serverError={fieldErrors.media}
          title={strings['signup.page.media.placeholder']}
          type="text"
          maxLength={200}
          value={form.media}
          validators={[
            {
              name: 'signupMedia',
              func: value => RE_MEDIA.test(value),
              message: strings['signup.page.media.error'],
            },
          ]}
          onValidate={setMediaValid}
        />
        <TextInputField
          isRequired
          isEmail
          name="email"
          serverError={fieldErrors.email}
          title={strings['signup.page.email.placeholder']}
          type="email"
          maxLength={320}
          value={form.email}
          validators={[
            {
              name: 'signupEmailLength',
              func: isEmailLengthValid,
              message: strings['signup.page.email.error'],
            },
            {
              name: 'signupEmailFormat',
              func: isEmailFormatValid,
              message: strings['signup.page.email.format_error'],
            },
          ]}
          onValidate={setEmailValid}
        />
        <TextInputField
          isRequired
          name="phone"
          serverError={fieldErrors.phone}
          title={strings['signup.page.phone.placeholder']}
          type="tel"
          maxLength={20}
          value={form.phone}
          validators={[
            {
              name: 'signupPhone',
              func: value => RE_PHONE.test(value) && /[0-9]/.test(value),
              message: strings['signup.page.phone.error'],
            },
          ]}
          onValidate={setPhoneValid}
        />

        <input
          type="text"
          name="website"
          defaultValue=""
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          style={{ position: 'absolute', left: '-9999px', opacity: 0 }}
        />

        <div className="auth-form__agreement">
          <Validator
            bool
            value={agreeTerms}
            validators={['isRequired']}
            onValidate={({ isValid }) => setTermsValid(isValid)}
            render={({ hasError }) => (
              <div className="auth-checkbox">
                <input
                  type="checkbox"
                  checked={agreeTerms}
                  onChange={ev => setAgreeTerms(ev.target.checked)}
                  className={Component.classList(
                    'auth-checkbox__input',
                    hasError && '_error'
                  )}
                  id="signup-page-agreeTerms"
                  name="agreeTerms"
                />
                <label
                  htmlFor="signup-page-agreeTerms"
                  className="auth-checkbox__label"
                >
                  {strings['signup.page.agreement.text']}{' '}
                  <Link to={privacyPolicy.getPath()}>
                    {strings['signup.page.agreement.privacy_link']}
                  </Link>{' '}
                  {strings['signup.page.agreement.and']}{' '}
                  <Link to={privacyPolicy.getPath()}>
                    {strings['signup.page.agreement.consent_link']}
                  </Link>
                </label>
              </div>
            )}
          />
        </div>

        {commonErrors.map(text => (
          <div className="error" key={text} role="alert">
            {text}
          </div>
        ))}
        {message && (
          <div className="error" role="alert">
            {message}
          </div>
        )}

        <button type="submit" className={buttonClassName} disabled={!canSubmit}>
          {loading
            ? strings['signup.page.submit.sending']
            : strings['signup.page.submit.text']}
        </button>
      </Form>
    </div>
  )
}

export function FormSignUp(props) {
  const { variant = 'modal' } = props

  if (variant === 'page') {
    return <FormSignUpPage {...props} />
  }

  return <FormSignUpModal {...props} />
}

export default DI(['user', 'recaptcha'])(withRouter(FormSignUp))
